<template>
  <div style="background-color:#fff;height:100vh;">
    <van-search v-model="orderNo" show-action placeholder="请输入委托单号" input-align="center">
      <template #action>
        <van-button type="primary" @click="onSearch">搜索</van-button>
      </template>
    </van-search>

    <van-notice-bar left-icon="volume-o" text="样品检测依次分为收样，加工，试验，报告阶段，请耐心等待我们最终的检测报告！" />

    <div v-if="list.length > 0">
      <div v-for="(item, index) in list" :key="index">
        <div class="mui-card" @click="getOrderDetail(item.OrderId)">
          <!--页眉，放置标题-->
          <div style="margin-bottom: 10px;">
            <van-steps :active="item.Stage">
              <van-step>收样</van-step>
              <van-step>加工</van-step>
              <van-step>试验</van-step>
              <van-step>报告</van-step>
            </van-steps>
          </div>

          <div class="mui-card-header">委托单号：{{ item.OrderId }}</div>
          <!--内容区-->
          <div class="mui-card-content">
            <div class="showdiv" style="margin-top:10px;">客户试样编号：{{ item.CustomerSampleNo || '--' }}</div>
            <div class="showdiv" style="margin-top:10px;">合同拟定日期：{{ item.ContractTime }}</div>
            <div class="showdiv" style="margin-top:10px;">预计完成日期：{{ item.PlanTime }}</div>
            <div class="showdiv" style="margin-top:10px;">送样日期：{{ item.SendSampleTime }}</div>
            <!-- <div class="showdiv" style="margin-top:10px;">
              收样日期：{{item.ReceivedTime}}
            </div> -->
            <div class="showdiv" style="margin-top:10px;">当前阶段：{{ item.CurStage }} {{ item.CompleteNum }}/{{ item.HandleNum }}</div>
            <div class="showdiv" style="margin-top:10px;">下一阶段：{{ item.NextStage }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="width:100%; height: 60px;color:#000;text-align:center;position: fixed;bottom: 0px;width:100%;background-color: #fff; padding: 5px;"
    >
      <h1>深海智慧检测（南京）有限公司</h1>
      <a href="http://beian.miit.gov.cn">苏ICP备2025181147号-1</a>
    </div>

    <!-- <Footer page="index"></Footer> -->
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import Vue from 'vue'
import { ContactCard, Search, Toast, NoticeBar, Step, Steps } from 'vant'
import axios from 'axios'

Vue.use(Step)
Vue.use(Steps)
Vue.use(ContactCard)
Vue.use(Search)
Vue.use(NoticeBar)
export default {
  data() {
    return {
      active: 0,
      list: [],
      orderNo: '',
      code: ''
    }
  },
  created() {
    let index = this.active + 1
    // this.code = this.getUrlCode().code;
    // this.getMyOrders()
  },
  components: {
    Footer
  },
  methods: {
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search
      this.winUrl = url
      var theRequest = new Object()
      if (url.indexOf('?') != -1) {
        var str = url.substr(1)
        var strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
    getMyOrders() {
      let _that = this
      axios
        .post(window.config.apiUrl + '/api/Public/GetOrdersNoReport', {
          OpenId: _that.code
        })
        .then(function(response) {
          let recvData = response.data
          if (recvData.code == 1) {
            _that.list = recvData.data
          } else {
            Toast.fail(recvData.msg)
          }
        })
        .catch(function(error) {
          Toast(error)
        })
    },
    onSearch() {
      var _that = this

      if (_that.orderNo == null || _that.orderNo == '') {
        Toast('请先输入委托单号！')
        return
      }
      _that.list = []

      const postLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '查询中...'
      })

      axios
        .get(window.config.apiUrl + '/api/Public/SearchOrder', {
          params: {
            orderId: _that.orderNo
          }
        })
        .then(function(response) {
          postLoading.clear()
          let recvData = response.data
          if (recvData.code !== 1) {
            Toast(recvData.msg)
            return
          }

          _that.list = []
          _that.list.push(recvData.data)
        })
        .catch(function(error) {
          Toast(error)
          postLoading.clear()
        })
    },
    getGoods() {
      var _that = this
      axios
        .get(window.config.apiUrl + '/api/Public/GetHistory', {
          params: {
            openId: '',
            pageSize: '',
            pageIndex: ''
          }
        })
        .then(function(response) {
          _that.list = response.data.data // this.list1
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    getOrderDetail(orderId) {
      this.$router.push('/cart?orderId=' + orderId + '&_t=' + Date.now())
    }
  }
}
</script>

<style>
.mui-card {
  padding: 10px;
  margin-top: 10px;
  background-color: #f8f8ff;
}
.mui-card-header {
}
</style>
